import React from "react";
import { WHATSAPP_ICON_PATH } from "../utility/support";

// The WhatsApp logo in currentColor (react-feather has none). Decorative:
// the text next to it says "WhatsApp".
const WhatsAppIcon = ({ className = "", size, ...rest }) => (
  <svg className={className} viewBox="0 0 20 20" width={size} height={size} fill="currentColor" aria-hidden="true" focusable="false" {...rest}>
    <path d={WHATSAPP_ICON_PATH} />
  </svg>
);

export default WhatsAppIcon;
